export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выбор валюты"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Суммы конвертируются по доступным курсам. Для пользовательских токенов курс задаётся эмитентом и носит информационный характер; ликвидность не гарантируется."])}
}